import { INavigationEntry } from '@types';
import { rootUrl, routes } from '@navigation/route-declarations';
import { useLocation, useNavigate } from 'react-router';
import { useEffect } from 'react';
import { searchInPath } from '@utils';

import { useAppTranslation } from './useAppTranslation';

type IColumnsOfEntries = {
  entries: Array<INavigationEntry>
  config: { iconColor?: string }
};

export const useNavigationEntries = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { translate } = useAppTranslation();

  useEffect(() => {
    redirectToProject();
  }, []);

  const redirectToProject = () => {
    if (searchInPath(rootUrl.navigate(), location.pathname)) {
      navigate(routes.projects.navigate());
    }
  };

  const firstColumn: IColumnsOfEntries = {
    entries: [
      /* HIDE
			 * {
				icon: "Speedometer02",
				title: "Dashboard",
				subtitle: "Insert subtitle",
				to: routes.dashboard.navigate(),
				isActive: (pathname) => pathname === routes.dashboard.navigate(),
				iconColor: "#15B79E",
			},*/
      {
        icon: 'Briefcase01',
        title: translate('navigation.projects'),
        route: 'projects',
        subtitle: 'Insert subtitle',
        iconColor: '#7057FF',
        to: routes.projects.navigate(),
        isActive: (pathname) => pathname.includes('project'),
      },
      {
        icon: 'User01',
        title: translate('navigation.certifications'),
        route: 'certifications',
        subtitle: 'Insert subtitle',
        iconColor: '#15B79E',
        to: routes.certifications.navigate(),
        isActive: (pathname) => pathname.includes('certification'),
      },
    ],
    config: { iconColor: '#15B79E' },
  };

  const secondColumn: IColumnsOfEntries = {
    entries: [
      {
        route: 'contributions',
        title: translate('navigation.contributions'),
        icon: 'Users01',
        subtitle: 'Insert subtitle',
        to: routes.contributions.navigate(),
        isActive: (pathname) => pathname.includes('contribution'),
        iconColor: '#2E90FA',
      },
      {
        title: translate('navigation.informations'),
        route: 'informations',
        icon: 'CheckVerified03',
        subtitle: 'Insert subtitle',
        to: routes.informations.navigate(),
        isActive: (pathname) => pathname.includes('informations'),
        iconColor: '#2E90FA',
      },
      // TODO HIDE - don't delete
      // {
      //   title: 'Activity',
      //   icon: 'Target03',
      //   subtitle: 'Insert subtitle',
      //   to: routes.activity.navigate(),
      //   isActive: (pathname) => pathname.includes(routes.activity.navigate()),
      //   iconColor: '#2E90FA',
      // },
    ],
    config: { iconColor: '#2E90FA' },
  };

  return {
    firstColumn,
    secondColumn,
  };
};
